//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { querySysCategoryTreeList } from '@/api/api';
import { getAction } from '@/api/manage';
import IwsUpload from '@comp/upload/IwsUpload';
import pick from 'lodash.pick';
import moment from 'moment';
import { ModalFormMixin } from '@/mixins/ModalFormMixin';
export default {
  name: 'ExplainModal',
  mixins: [ModalFormMixin],
  components: {
    IwsUpload: IwsUpload
  },
  data: function data() {
    return {
      form: this.$form.createForm(this),
      siteList: [],
      title: '',
      queryParam: {},
      categoryTree: [],
      disableSubmit: true,
      visible: false
    };
  },
  created: function created() {
    this.loadTree();
  },
  methods: {
    add: function add(record) {
      this.edit(record);
    },
    edit: function edit(record) {
      var _this = this;

      console.log(record);
      this.title = record.title + '详情';
      this.hiding = false;
      this.fileDelList = [];
      this.docId = record.id;
      this.form.resetFields();
      this.model = Object.assign({}, record);
      console.log('this.model', this.model);
      this.$nextTick(function () {
        _this.form.setFieldsValue(pick(_this.model, 'category', 'title', 'keyword', 'sort', 'remark', 'createBy_userName', 'createTime', 'updateBy_userName', 'updateTime')); //时间格式化


        _this.form.setFieldsValue({
          createTime: _this.model.createTime ? moment(_this.model.createTime) : null
        });

        _this.form.setFieldsValue({
          updateTime: _this.model.updateTime ? moment(_this.model.updateTime) : null
        });
      });
    },
    loadTree: function loadTree() {
      var _this2 = this;

      var that = this;
      that.categoryTree = [];
      var param = {
        pid: 1
      };
      querySysCategoryTreeList(param).then(function (res) {
        if (res.success) {
          for (var i = 0; i < res.result.length; i++) {
            var temp = res.result[i];
            that.categoryTree.push(temp);
          }

          _this2.loading = false;
        }
      });
    },
    handleCancel: function handleCancel() {
      this.visible = false;
    },
    handleOk: function handleOk() {
      this.visible = false;
    },
    // 从巡检单进入查找巡检说明详情
    getExplainDetaul: function getExplainDetaul(id) {
      var _this3 = this;

      getAction('/sys/doc/queryById?id=' + id).then(function (res) {
        if (res.success) {
          _this3.edit(res.result);
        }
      });
    }
  }
};